'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from '@lichtblick/photon/atoms/text/text';
import { CheckboxInput } from '@lichtblick/photon/molecules/legacy-checkbox/checkbox-input';
import styles from './Checkbox.module.scss';
import { withValidation } from './Form.helpers';
export const Checkbox = withValidation(({ hasError, label, labelSlot, statusType, subLabel, ...props })=>/*#__PURE__*/ _jsx(CheckboxInput, {
        ...props,
        hasError: statusType === 'error' || hasError,
        labelSlot: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                label ?? labelSlot,
                subLabel && /*#__PURE__*/ _jsx(Text, {
                    className: styles['sub-label'],
                    size: "xs",
                    children: subLabel
                })
            ]
        })
    }));

//# sourceMappingURL=Checkbox.js.map